import React,{ useState, useEffect } from "react";
import api from "../../services/api";
import {
    Container,
    Row,
    Col,
    Hidden,
    ScreenClassRender
} from "react-grid-system";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import ModalFuncaoBloqueada from '../../components/modal/modalFuncaoBloqueada';
import GenericUpper from "../../components/generic-upper";
import Select from "../../components/select";
import SelectV2 from "../../components/select/select_v2";
import Input from "../../components/input";
import InputV2 from "../../components/input/input_v2";
import Button from "../../components/button";
import ButtonV2 from '../../components/button/button_v2';
import { store } from "react-notifications-component";
import Table from "../../components/table";
import TBody from "../../components/tbody";
import InputSearch from "../../components/input-search";
import { Link } from "react-router-dom";
import DotsLoader from "../../components/loader";
import ModalTesteGratisAcabou from '../../components/modal/modalFuncaoBloqueada';

import CardGeral from "../../components/card-geral";
import { UserIndexContainer } from "./styles";
import { BodyP, BodyPSpan, H5, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import { isTotvs, isTotvsProtheus } from "../../services/globalFunctions";
import InputV3 from "../../components/input/novo/input_v3";

import * as S from './styles';
import AcordionCard from "../../components/acordionCard";
import TextOrStatus from "../../components/textOrStatus";

export const USER = "@userinfo";
export const VAL = "@validade";

const Usuario = ({...props}) => {

    const [userInfo, setUserInfo] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hideButton, setHideButton] = useState(false);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(5);
    const [result, setResult] = useState('');
    const [userr] = useState(JSON.parse(localStorage.getItem(USER)));
    const [val] = useState(JSON.parse(localStorage.getItem(VAL)));
    const [modalTesteGratis, setModalTesteGratis] = useState(false);
    const [modalTesteGratisAcabou, setModalTesteGratisAcabou] = useState(false);

    const [userLicencasData, setUserLicencasData] = useState({});

    //TOTVS
    const [loadingGetUser, setLoadingGetUser] = useState(false);
    const [loadingAddTotvs, setLoadingAddTotvs] = useState(false);

    const [newUsers, setNewUsers] = useState([]);
    const [newUserTotvs, setNewUserTotvs] = useState({
        nome: '',
        email: '',
        whatsapp: ''
    });

    const [permissoes, setPermissoes] = useState([])
    const [permissaoId, setPermissaoId] = useState('');
    const [permissaoLabel, setPermissaoLabel] = useState('');
    const [userId, setUserId] = useState('');
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [enviarReceita, setEnviarReceita] = useState(0);

    const [lojas, setLojas] = useState([]);
    const [lojaId, setLojaId] = useState('');
    const [lojaLabel, setLojaLabel] = useState('');
    const [whatsapp, setWhatsapp] = useState('');

    const [openAccordionKey, setOpenAccordionKey] = useState(null);
    const [openNewUserAccordionKey, setOpenNewUserAccordionKey] = useState(null);
    const [userFormsById, setUserFormsById] = useState({});
    const [newUserFormsById, setNewUserFormsById] = useState({});

    const [erroNome, setErroNome] = useState(false);
    const [erroEmail, setErroEmail] = useState(false);
    const [erroPermissao, setErroPermissao] = useState(false);
    const [erroLoja, setErroLoja] = useState(false);
    const [erroWhatsapp, setErroWhatsapp] = useState(false);


    const getUsers = async (searchText = "") => {
        await setUserInfo(localStorage.getItem(USER));
        
        try {
            const payload = {
                search: searchText
            }

            const response = await api.post(`/users/pesquisa?limit=30&offset=0`, payload);
            await setUsuarios(response.data.data);
            setLoading(false);
            
        } catch (error) {
            setLoading(false);
            setHideButton(true);
            
        }
        
    } 

    const updateValues = async (text, estado, search) => {
        if (search === 1) {
            if (!text) {
                searchData('');
            }else{
                setResult(text);
                searchData(text);
            }
        }else{
            setResult(text);
        }
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            searchData(e.target.value);
        }
    }


    const loadMore = async () => {
        setLoading(true);
        setHideButton(true);
        const newOffset = limit + offset;

        try {
            setUserInfo(localStorage.getItem(USER)); 
            
            const payload = {
                search: result || ""
            }

            const response = await api.post(`/users/pesquisa?limit=30&offset=0`, payload);

            let newUsers = response.data.data;
            const UserConCat = usuarios.concat(newUsers);
            
            setUsuarios(UserConCat);
            
            setOffset(newOffset);
            setHideButton(false);

        } catch (erro) {
            setHideButton(true);
        }
        setLoading(false);

    };

    //função para realizar buscas dos campos
    const searchData = async (text = '') => {
        try {
            if (text.length < 1 && text !== '') {
                return;
            }

            const payload = {
                search: text || ""
            }

            if (text !== '') {
                const response = await api.post(`/users/pesquisa?limit=30&offset=0`, payload);

                setUsuarios(response.data.data);
            }else{
                const response = await api.post(`/users/pesquisa?limit=30&offset=0`, payload);

                setUsuarios(response.data.data);
            }
        } catch (error) {
            setUsuarios([]);
        }
    };

    const getNumberUsers = async () => {
        try {
            const response = await api.get(`/users/qtd-licencas`);

            setUserLicencasData(response.data);
        } catch (error) {}
    }

    const getNewUsersTotvs = async () => {
        setLoadingGetUser(true);
        
        try {
            const response = await api.get(`/novos-usuarios`);

            setNewUsers(response.data.data);
        } catch (error) {
        } finally {
            setLoadingGetUser(false);
        }
    }

    const handleAddUserTotvs = async () => {
        setLoadingAddTotvs(true);

        try {
            validarCampos();

            const payload = {
                agro_permission_id: permissaoId,
                new_user_id: userId,
                username: email,
                agro_subsidiary_id: lojaId ? lojaId : '',
                status: 'AT',
                name: nome,
                whatsapp,
                enviar_receita: 1
            }

            const response = await api.post(`/users`, payload);

           if (response.status === 201) {
                setNome("");
                setEmail("");
                setWhatsapp("");
                setLojaId("");
                setPermissaoId("");

                getUsers();
                getNumberUsers();
                getNewUsersTotvs();

                store.addNotification({
                    title: "Sucesso!",
                    message: "Usuário adicionado com sucesso",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
           }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });

            if (error.response.status === 422) {
                setErroEmail(true)
            }
        } 
        finally {
            setLoadingAddTotvs(false);
        }
    }

    const getPermission = async () => {
        const response = await api.get(`/users/nivel/permissao`);
      
        const niveis = response.data.data.nivel[0];

        const descricoesPermissao = {
          1: 'Acesso total ao sistema.',
          2: 'Acesso restrito à sua filial.',
          3: 'Acesso operacional. Focado na emissão de receitas e consulta de solicitações. Visualiza apenas os dados da própria filial.',
        };

        const permissoesFormatadas = Object.entries(niveis).map(([key, value]) => ({
          value: Number(key),
          label: value,
          description: descricoesPermissao[Number(key)] || undefined,
        }));

        setPermissoes(permissoesFormatadas);
    };

    const getFiliais = async () => {
        try {
            const response = await api.get("/filiais");
            const filiais = response.data.data;
            
            if (filiais && filiais.length > 0) {
                let filialFormat = formatFiliais(filiais);
                setLojas(filialFormat);
                
            } else {
                setLojas([]);
                store.addNotification({
                    title: "Atenção!",
                    message: "Nenhuma filial encontrada",
                    type: "warning",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } catch (e) {
        }
    };

    const validatePermissao = async (permissao) => {
        setPermissaoId(permissao.value);
        setPermissaoLabel(permissao.label);
    }

    const validateNome = async (nome) => {
        setNome(nome);
    }

    const validateEmail = async (email) => {
        setEmail(email);
    }

    const validateLoja = async (loja) => {
        setLojaId(loja.value);
        setLojaLabel(loja.label);
    }

    const formatFiliais = (filiais) => {
        let resultFilial = [];
        filiais.map(f => {
            let format = {value: f.id, label: f.nome_fantasia}
            resultFilial = [...resultFilial, format];
        })

        return resultFilial;
    }

    const validateWhatsapp = async (whatsapp) => {
        const numeroLimpo = whatsapp.replace(/\D/g, '');
        
        let numeroFormatado = '';
        
        if (numeroLimpo.length <= 10) {
            numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{4})(\d{4}).*/, '($1)$2-$3');
        } else {
            numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1)$2-$3');
        }
        
        if (numeroLimpo.length < 10) {
            if (numeroLimpo.length <= 2) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2}).*/, '($1)');
            } else if (numeroLimpo.length <= 6) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{0,4}).*/, '($1)$2');
            } else if (numeroLimpo.length <= 10) {
                numeroFormatado = numeroLimpo.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1)$2-$3');
            }
        }
        
        setWhatsapp(numeroFormatado);
        setErroWhatsapp(false);
    }

    const opStatus = [
        { value: "AT", label: "Ativo" },
        { value: "IN", label: "Inativo" },
    ];

    const setUserFormPatch = (userId, patch) => {
        setUserFormsById((prev) => {
            const current = prev?.[userId] || {};
            const nextErrors =
                patch?.errors && typeof patch.errors === "object"
                    ? { ...(current.errors || {}), ...patch.errors }
                    : current.errors;

            const next = {
                ...current,
                ...patch,
                ...(nextErrors ? { errors: nextErrors } : {}),
            };
            return { ...prev, [userId]: next };
        });
    };

    const setNewUserFormPatch = (newUserId, patch) => {
        setNewUserFormsById((prev) => {
            const current = prev?.[newUserId] || {};
            const nextErrors =
                patch?.errors && typeof patch.errors === "object"
                    ? { ...(current.errors || {}), ...patch.errors }
                    : current.errors;

            const next = {
                ...current,
                ...patch,
                ...(nextErrors ? { errors: nextErrors } : {}),
            };

            return { ...prev, [newUserId]: next };
        });
    };

    const formatWhatsappFromApi = (raw) => {
        if (!raw) return "";

        let digits = raw.replace(/\D/g, '');

        if (digits.length > 11 && digits.startsWith('55')) {
            digits = digits.slice(2);
        }

        if (digits.length === 11) {
            return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1)$2-$3');
        }

        if (digits.length === 10) {
            return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1)$2-$3');
        }

        return raw;
    };

    const loadUserForm = async (userId, force = false) => {
        if (!userId) return;

        const existing = userFormsById?.[userId];
        if (existing?.loading) return;
        if (!force && existing?.loaded) return;

        setUserFormPatch(userId, {
            loading: true,
            loaded: false,
            saving: false,
            errors: {},
        });

        try {
            const response = await api.get(`/users/${userId}`);
            const user = response?.data?.data || {};

            setUserFormPatch(userId, {
                loading: false,
                loaded: true,
                nome: user?.name || "",
                permissaoId: user?.agro_permission_id || "",
                email: user?.username || "",
                lojaId: user?.agro_subsidiary_id || "",
                status: user?.status || "",
                enviar_receita: user?.enviar_receita ?? "",
                whatsapp: formatWhatsappFromApi(user?.contacts?.whatsapp),
                disabledUserInativo: user?.status === "IN",
                errors: {},
            });
        } catch (error) {
            setUserFormPatch(userId, { loading: false, loaded: false });
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
        }
    };

    const validateUserForm = (form) => {
        const nomeOk = !!form?.nome;
        const emailOk = !!form?.email;
        const permissaoOk = !!form?.permissaoId;
        const lojaOk = !!form?.lojaId;
        const statusOk = !!form?.status;
        const whatsappValido = !form?.whatsapp || form.whatsapp.length === 13 || form.whatsapp.length === 14;

        return {
            hasError: !nomeOk || !emailOk || !permissaoOk || !lojaOk || !statusOk || !whatsappValido,
            errors: {
                nome: !nomeOk,
                email: !emailOk,
                permissao: !permissaoOk,
                loja: !lojaOk,
                status: !statusOk,
                whatsapp: !whatsappValido,
            },
        };
    };

    const saveUserForm = async (userId) => {
        if (!userId) return;

        const form = userFormsById?.[userId] || {};
        const validation = validateUserForm(form);
        setUserFormPatch(userId, { errors: validation.errors });

        if (validation.hasError) {
            store.addNotification({
                title: "Erro!",
                message: "Preencha todos os campos obrigatórios",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
            return;
        }

        setUserFormPatch(userId, { saving: true });
        try {
            const payload = {
                agro_permission_id: form.permissaoId,
                username: form.email,
                agro_subsidiary_id: form.lojaId ? form.lojaId : "",
                status: form.status,
                name: form.nome,
                enviar_receita: form.enviar_receita,
                whatsapp: form.whatsapp,
            };

            await api.put(`/users/${userId}`, payload);
            await getUsers();
            await loadUserForm(userId, true);
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
        } finally {
            setUserFormPatch(userId, { saving: false });
        }
    };

    const initNewUserForm = (newUser, force = false) => {
        if (!newUser?.id) return;

        const existing = newUserFormsById?.[newUser.id];
        if (existing && !force) return;

        const nomeInicial = newUser?.nome ?? newUser?.name ?? "";
        const emailInicial = newUser?.email ?? newUser?.username ?? "";
        const whatsappInicial = newUser?.telefone ?? newUser?.whatsapp ?? "";
        const permissaoInicial = permissoes?.[0]?.value ?? "";

        setNewUserFormPatch(newUser.id, {
            permissaoId: existing?.permissaoId || permissaoInicial,
            lojaId: existing?.lojaId || "",
            nome: existing?.nome || nomeInicial,
            email: existing?.email || emailInicial,
            whatsapp: existing?.whatsapp || whatsappInicial,
            saving: false,
            errors: existing?.errors || {},
        });
    };

    useEffect(() => {
        const defaultPermissaoId = permissoes?.[0]?.value;
        if (!defaultPermissaoId) return;

        setNewUserFormsById((prev) => {
            const next = { ...prev };
            for (const [id, form] of Object.entries(next)) {
                if (!form?.permissaoId) {
                    next[id] = { ...form, permissaoId: defaultPermissaoId };
                }
            }
            return next;
        });
    }, [permissoes]);

    const validateNewUserForm = (form) => {
        const nomeOk = !!form?.nome;
        const emailOk = !!form?.email;
        const permissaoOk = !!form?.permissaoId;
        const lojaOk = !!form?.lojaId;
        const whatsappDigits = String(form?.whatsapp ?? "").replace(/\D/g, "");
        const whatsappValido = whatsappDigits.length === 0 || whatsappDigits.length === 10 || whatsappDigits.length === 11 || whatsappDigits.length === 12 || whatsappDigits.length === 13;

        return {
            hasError: !nomeOk || !emailOk || !permissaoOk || !lojaOk || !whatsappValido,
            errors: {
                nome: !nomeOk,
                email: !emailOk,
                permissao: !permissaoOk,
                loja: !lojaOk,
                whatsapp: !whatsappValido,
            },
        };
    };

    const saveNewUserTotvs = async (newUserId) => {
        if (!newUserId) return;
        const form = newUserFormsById?.[newUserId] || {};

        const validation = validateNewUserForm(form);
        setNewUserFormPatch(newUserId, { errors: validation.errors });

        if (validation.hasError) {
            store.addNotification({
                title: "Erro!",
                message: "Preencha todos os campos obrigatórios",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });
            return;
        }

        setNewUserFormPatch(newUserId, { saving: true });
        setLoadingAddTotvs(true);
        try {
            const payload = {
                agro_permission_id: form.permissaoId,
                new_user_id: newUserId,
                username: form.email,
                agro_subsidiary_id: form.lojaId ? form.lojaId : "",
                status: "AT",
                name: form.nome,
                whatsapp: form.whatsapp,
                enviar_receita: 1,
            };

            const response = await api.post(`/users`, payload);
            if (response?.status === 201) {
                await getUsers();
                await getNumberUsers();
                await getNewUsersTotvs();
                setOpenNewUserAccordionKey(null);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true,
                },
            });

            if (error.response.status === 422) {
                setNewUserFormPatch(newUserId, { errors: { email: true } });
            }
        } finally {
            setNewUserFormPatch(newUserId, { saving: false });
            setLoadingAddTotvs(false);
        }
    };

    const validarCampos = () => {
        setErroNome(!nome);
        setErroEmail(!email);
        setErroPermissao(!permissaoId);
        setErroLoja(!lojaId);
        
        const whatsappValido = !whatsapp || whatsapp.length === 13 || whatsapp.length === 14;
        setErroWhatsapp(!whatsappValido);

        return !nome || !email || !permissaoId || !lojaId  || !whatsappValido;
    }

    useEffect(() => {
        getUsers();
        getNumberUsers();
        getPermission();
        getFiliais();
        //Totvs
        if (isTotvs() && userr.agro_permission_id === 4) {
            getNewUsersTotvs();
        }
    },[])

    useEffect(() => {
        if (usuarios.length === 0) {
            searchData();
        }
    },[])

    console.log("userr", userr.agro_permission_id)

    const usersList = Array.isArray(usuarios?.usuarios) ? usuarios.usuarios : [];

    // Conta master (Administrador Matriz) no limite de licenças - o botão "Adicionar"
    // fica cinza e, ao passar o mouse, mostra um link pra tela de aquisição de licenças.
    // agro_permission_id === 4 é o admin master pra contas TOTVS/Omie (mesmo padrão já
    // usado nesta própria tela nas linhas acima e no navbar).
    const isContaMaster = userr?.agro_permission_id === 4;
    const limiteLicencasAtingido =
        Number(userLicencasData?.qtd_adquirida) > 0 &&
        Number(userLicencasData?.qtd_licencas) >= Number(userLicencasData?.qtd_adquirida);
    const bloqueadoPorLimiteLicencas = isContaMaster && limiteLicencasAtingido;

    
    return(
        <ScreenClassRender
            render={screenClass => (
                <>
                    <GenericUpper
                        title="Usuários"
                        subtitle="Gerencie seus usuários"
                        search={true}
                        searchFunction={(text, estado, search) => updateValues(text, estado, search)}
                        onKeyDown={(e) => onKeyDown(e)}
                        addButton={true}
                        tooltip={"Adicionar"}
                        placeholder={'E-mail'}
                        linkSearch={'/usuarios/add'}
                        disabled={isTotvsProtheus() || bloqueadoPorLimiteLicencas}
                        addButtonBlockedLinkHref={bloqueadoPorLimiteLicencas ? '/plano/edit' : undefined}
                        addButtonBlockedLinkText="Você precisa adquirir mais licenças. Adquira mais licenças"
                    ></GenericUpper>
                    <UserIndexContainer>
                        <Container>
                            {loading ? (
                                 <div style={{width: '100%', height: 'auto', padding: '190px 0 0',display: 'flex', justifyContent: 'center'}}>
                                    <S.Loading />
                                </div>
                            ) :(
                                <>
                                    <div style={{width: '100%', height: 'auto', padding: '0 0 32px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                        <BodyPSpan color={theme.colors.gray.Cinza_2} style={{width: 'auto'}}>
                                            Quantidade de usuários do seu plano: {userLicencasData?.qtd_licencas?.toString()}/{userLicencasData?.qtd_adquirida?.toString()}
                                        </BodyPSpan>
                                    </div>
                                    
                                    <div style={{width: '100%', height: 'auto', display: 'flex', flexDirection: 'column', gap: '32px'}}>
                                        {usersList.length > 0 ? (
                                            usersList.map((user) => {
                                                const userId = user?.id;
                                                const userEmail = user?.username || user?.email || "-";
                                                const userPermissionRaw = user?.agro_permission?.permission || "-";
                                                const userPermission =
                                                    userPermissionRaw === "Administrador Matriz"
                                                        ? "Adm Matriz"
                                                        : userPermissionRaw === "Administrador Filial"
                                                        ? "Adm Filial"
                                                        : userPermissionRaw;
                                                const userSubsidiary = user?.agro_subsidiary?.nome_fantasia || "-";
                                                const userCity = `${user?.agro_subsidiary?.cidade} (${user?.agro_subsidiary?.estado})` || user?.agro_subsidiary?.cidade || "-";
                                                const userCompany = user?.agro_subsidiary?.is_matriz === 1 ? "Matriz" : "Filial";
                                                const userStatus = user?.status === "AT" ? "ATIVO" : "INATIVO";
                                                const userTitle =
                                                    user?.name ||
                                                    user?.nome ||
                                                    user?.username ||
                                                    user?.email ||
                                                    (userId ? `Usuário ${userId}` : "Usuário");
                                                const accordionKey = userId ?? userEmail;
                                                const form = userId ? userFormsById?.[userId] : null;

                                                return (
                                                    <AcordionCard
                                                        maxWidth="880px"
                                                        maxWidthAcordionHeader="100%"
                                                        key={userId ?? userEmail}
                                                        accordionKey={accordionKey}
                                                        title={userTitle}
                                                        titleColor={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}
                                                        isOpen={openAccordionKey === accordionKey}
                                                        onToggle={() => {
                                                            if (openAccordionKey === accordionKey) {
                                                                setOpenAccordionKey(null);
                                                            } else {
                                                                setOpenAccordionKey(accordionKey);
                                                                if (userId) {
                                                                    loadUserForm(userId);
                                                                }
                                                            }
                                                        }}
                                                        showContentAcordionClose={true}
                                                        contentAcordionClose={
                                                            <S.ContainerContentAcordion>
                                                                <S.ContainerDetails>
                                                                    <TaglineP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>E-mail</TaglineP>

                                                                    <BodyP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={theme.typography.fontWeight.bold}>
                                                                        {userEmail}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>Loja</TaglineP>
                                                                    
                                                                    <BodyP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={theme.typography.fontWeight.bold}>
                                                                        {userSubsidiary}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>Cidade</TaglineP>

                                                                    <BodyP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={theme.typography.fontWeight.bold}>
                                                                        {userCity}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>Perfil</TaglineP>

                                                                    <BodyP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2} fontWeight={theme.typography.fontWeight.bold}>
                                                                        {userPermission}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP color={user?.status !== "AT" ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>Status</TaglineP>

                                                                    <TextOrStatus
                                                                        maxWidth="auto"
                                                                        type="status"
                                                                        status={user?.status === "AT" ? 2 : 3}
                                                                        textSuccess="Ativo"
                                                                        textError="Inativo"
                                                                        textDefault="Ativo"
                                                                        />
                                                                </S.ContainerDetails>
                                                            </S.ContainerContentAcordion>
                                                        }
                                                    >
                                                        {userId ? (
                                                            form?.loaded ? (
                                                                <div style={{ width: "100%", maxWidth: "375px", padding: "16px 0 0", display: "flex", flexDirection: "column", gap: "16px" }}>
                                                                    <SelectV2
                                                                        label="Permissão"
                                                                        labelWithAsterisk={true}
                                                                        id={`permission_${userId}`}
                                                                        options={permissoes}
                                                                        value={form?.permissaoId}
                                                                        onChange={(e) => {
                                                                            setUserFormPatch(userId, {
                                                                                permissaoId: e?.value,
                                                                                errors: { permissao: false },
                                                                            });
                                                                        }}
                                                                        disabled={form?.disabledUserInativo}
                                                                        erro={!!form?.errors?.permissao}
                                                                        marginBottom="32px"
                                                                        height="auto"
                                                                    />

                                                                    <InputV2
                                                                        label="Nome"
                                                                        labelWithAsterisk={true}
                                                                        name="nome"
                                                                        id={`name_${userId}`}
                                                                        value={form?.nome}
                                                                        onChange={(e) => {
                                                                            setUserFormPatch(userId, { nome: e, errors: { nome: false } });
                                                                        }}
                                                                        disabled={form?.disabledUserInativo}
                                                                        erro={!!form?.errors?.nome}
                                                                        marginBottom="0px"
                                                                        height="auto"
                                                                    />

                                                                    {form?.enviar_receita !== "" && (
                                                                        <S.ContainerInput>
                                                                            <InputV2
                                                                                label="Email"
                                                                                labelWithAsterisk={true}
                                                                                type="email"
                                                                                name="email"
                                                                                id={`username_${userId}`}
                                                                                value={form?.email}
                                                                                onChange={(e) => {
                                                                                    setUserFormPatch(userId, { email: e, errors: { email: false } });
                                                                                }}
                                                                                disabled={form?.disabledUserInativo}
                                                                                yesNo={true}
                                                                                messageYesNo={"enviar receitas por email"}
                                                                                onChangeYesNo={(e) => setUserFormPatch(userId, { enviar_receita: e ? 1 : 0 })}
                                                                                initialYesNoValue={form?.enviar_receita}
                                                                                erro={!!form?.errors?.email}
                                                                                marginBottom="0px"
                                                                                height="auto"
                                                                            />
                                                                        </S.ContainerInput>
                                                                    )}

                                                                    <InputV2
                                                                        name="whatsapp"
                                                                        value={form?.whatsapp}
                                                                        type="text"
                                                                        label="Whatsapp"
                                                                        labelWithAsterisk={false}
                                                                        id={`whatsapp_${userId}`}
                                                                        onChange={(e) => {
                                                                            setUserFormPatch(userId, { whatsapp: e, errors: { whatsapp: false } });
                                                                        }}
                                                                        inputmode="numeric"
                                                                        erro={!!form?.errors?.whatsapp}
                                                                        marginBottom="12px"
                                                                        height="auto"
                                                                    />

                                                                    <SelectV2
                                                                        label="Loja"
                                                                        labelWithAsterisk={true}
                                                                        id={`loja_id_${userId}`}
                                                                        options={lojas}
                                                                        value={form?.lojaId}
                                                                        onChange={(e) => {
                                                                            setUserFormPatch(userId, { lojaId: e?.value, errors: { loja: false } });
                                                                        }}
                                                                        disabled={form?.disabledUserInativo}
                                                                        erro={!!form?.errors?.loja}
                                                                        marginBottom="32px"
                                                                        height="auto"
                                                                    />

                                                                    <SelectV2
                                                                        label="Status"
                                                                        labelWithAsterisk={true}
                                                                        id={`status_id_${userId}`}
                                                                        options={opStatus}
                                                                        value={form?.status}
                                                                        onChange={(e) => {
                                                                            setUserFormPatch(userId, {
                                                                                status: e?.value,
                                                                                errors: { status: false },
                                                                            });
                                                                        }}
                                                                        erro={!!form?.errors?.status}
                                                                        marginBottom="12px"
                                                                        height="auto"
                                                                    />

                                                                    <div
                                                                        className="cadastrar"
                                                                        id={`save_${userId}`}
                                                                        style={{
                                                                            width: "100%",
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            justifyContent: "space-evenly",
                                                                            gap: "12px",
                                                                        }}
                                                                    >
                                                                        <ButtonV2
                                                                            width="45%"
                                                                            height="50px"
                                                                            value="VOLTAR"
                                                                            outline={true}
                                                                            disabled={false}
                                                                            onClick={() => setOpenAccordionKey(null)}
                                                                            loading={false}
                                                                        />
                                                                        <ButtonV2
                                                                            width="45%"
                                                                            height="50px"
                                                                            value="SALVAR"
                                                                            outline={false}
                                                                            disabled={isTotvs() && userr.agro_permission_id !== 4}
                                                                            onClick={() => saveUserForm(userId)}
                                                                            loading={!!form?.saving}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
                                                                    <S.Loading />
                                                                </div>
                                                            )
                                                        ) : null}
                                                    </AcordionCard>
                                                );
                                            })
                                            ) : (
                                                <div style={{ width: "100%", padding: "16px 0", display: "flex", justifyContent: "center" }}>
                                                    <BodyPSpan color={theme.colors.gray.Cinza_2} style={{ width: "auto", textAlign: "center" }}>
                                                        Nenhum resultado encontrado.
                                                    </BodyPSpan>
                                                </div>
                                        )}
                                    </div>
                                </>
                            )} 

                            {!loading && isTotvs() && userr?.agro_permission_id === 4 && newUsers.length > 0 ? (
                                <div style={{ width: "100%", marginTop: "32px" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            padding: "32px 0",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                        }}
                                    >
                                        <BodyPSpan color={theme.colors.gray.Cinza_2} style={{ width: "auto" }}>
                                            Novos usuários
                                        </BodyPSpan>
                                    </div>

                                    <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "32px" }}>
                                        {newUsers.length > 0 ? (
                                            newUsers.map((newUser) => {
                                                const accordionKey = newUser?.id ?? newUser?.email ?? newUser?.nome ?? "novo-usuario";
                                                const newUserId = newUser?.id;
                                                const form = newUserId ? newUserFormsById?.[newUserId] : null;

                                                return (
                                                    <AcordionCard
                                                        key={accordionKey}
                                                        maxWidth="880px"
                                                        maxWidthAcordionHeader="100%"
                                                        accordionKey={accordionKey}
                                                        title={newUser?.nome || "Novo usuário"}
                                                        isOpen={openNewUserAccordionKey === accordionKey}
                                                        onToggle={() => {
                                                            if (openNewUserAccordionKey === accordionKey) {
                                                                setOpenNewUserAccordionKey(null);
                                                                return;
                                                            }
                                                            setOpenNewUserAccordionKey(accordionKey);
                                                            initNewUserForm(newUser, true);
                                                        }}
                                                        showContentAcordionClose={true}
                                                        contentAcordionClose={
                                                            <S.ContainerContentAcordion>
                                                                <S.ContainerDetails>
                                                                    <TaglineP>E-mail</TaglineP>
                                                                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                                                                        {newUser?.email || "-"}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP>Whatsapp</TaglineP>
                                                                    <BodyP fontWeight={theme.typography.fontWeight.bold}>
                                                                        {newUser?.telefone || "-"}
                                                                    </BodyP>
                                                                </S.ContainerDetails>

                                                                <S.ContainerDetails>
                                                                    <TaglineP>Status</TaglineP>
                                                                    <TextOrStatus
                                                                        maxWidth="auto"
                                                                        type="status"
                                                                        status={1}
                                                                        textDefault="Pendente"
                                                                        textSuccess="Pendente"
                                                                        textError="Pendente"
                                                                    />
                                                                </S.ContainerDetails>
                                                            </S.ContainerContentAcordion>
                                                        }
                                                    >
                                                        {newUserId ? (
                                                            form ? (
                                                            <div style={{ width: "100%", maxWidth: "375px", padding: "16px 0 0", display: "flex", flexDirection: "column", gap: "16px" }}>
                                                                <SelectV2
                                                                    label="Permissão"
                                                                    labelWithAsterisk={true}
                                                                    id={`permission_new_${newUserId}`}
                                                                    options={permissoes}
                                                                    value={form?.permissaoId ?? ""}
                                                                    onChange={(e) => {
                                                                        setNewUserFormPatch(newUserId, {
                                                                            permissaoId: e?.value,
                                                                            errors: { permissao: false },
                                                                        });
                                                                    }}
                                                                    disabled={false}
                                                                    erro={!!form?.errors?.permissao}
                                                                    marginBottom="32px"
                                                                    height="auto"
                                                                />

                                                                <InputV2
                                                                    label="Nome"
                                                                    labelWithAsterisk={true}
                                                                    name="nome"
                                                                    id={`name_new_${newUserId}`}
                                                                    value={form?.nome ?? ""}
                                                                    onChange={(e) => {
                                                                        setNewUserFormPatch(newUserId, { nome: e, errors: { nome: false } });
                                                                    }}
                                                                    disabled={false}
                                                                    erro={!!form?.errors?.nome}
                                                                    marginBottom="0px"
                                                                    height="auto"
                                                                />

                                                                <S.ContainerInput>
                                                                    <InputV2
                                                                        label="Email"
                                                                        labelWithAsterisk={true}
                                                                        type="email"
                                                                        name="email"
                                                                        id={`username_new_${newUserId}`}
                                                                        value={form?.email ?? ""}
                                                                        onChange={(e) => {
                                                                            setNewUserFormPatch(newUserId, { email: e, errors: { email: false } });
                                                                        }}
                                                                        disabled={false}
                                                                        yesNo={false}
                                                                        messageYesNo={"enviar receitas por email"}
                                                                        erro={!!form?.errors?.email}
                                                                        marginBottom="0px"
                                                                        height="auto"
                                                                    />
                                                                </S.ContainerInput>

                                                                <InputV2
                                                                    name="whatsapp"
                                                                    value={form?.whatsapp ?? ""}
                                                                    type="text"
                                                                    label="Whatsapp"
                                                                    labelWithAsterisk={false}
                                                                    id={`whatsapp_new_${newUserId}`}
                                                                    onChange={(e) => {
                                                                        setNewUserFormPatch(newUserId, { whatsapp: e, errors: { whatsapp: false } });
                                                                    }}
                                                                    inputmode="numeric"
                                                                    erro={!!form?.errors?.whatsapp}
                                                                    marginBottom="12px"
                                                                    height="auto"
                                                                />

                                                                <SelectV2
                                                                    label="Loja"
                                                                    labelWithAsterisk={true}
                                                                    id={`loja_id_new_${newUserId}`}
                                                                    options={lojas}
                                                                    value={form?.lojaId ?? ""}
                                                                    onChange={(e) => {
                                                                        setNewUserFormPatch(newUserId, { lojaId: e?.value, errors: { loja: false } });
                                                                    }}
                                                                    selectUniqueOption={true}
                                                                    disabled={false}
                                                                    erro={!!form?.errors?.loja}
                                                                    marginBottom="32px"
                                                                    height="auto"
                                                                />

                                                                <div
                                                                    className="cadastrar"
                                                                    id={`save_new_${newUserId}`}
                                                                    style={{
                                                                        width: "100%",
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        justifyContent: "space-evenly",
                                                                        gap: "12px",
                                                                    }}
                                                                >
                                                                    <ButtonV2
                                                                        width="45%"
                                                                        height="50px"
                                                                        value="VOLTAR"
                                                                        outline={true}
                                                                        disabled={false}
                                                                        onClick={() => setOpenNewUserAccordionKey(null)}
                                                                        loading={false}
                                                                    />

                                                                    <ButtonV2
                                                                        width="45%"
                                                                        height="50px"
                                                                        value="SALVAR"
                                                                        outline={false}
                                                                        disabled={userr.agro_permission_id !== 4}
                                                                        onClick={() => saveNewUserTotvs(newUserId)}
                                                                        loading={!!form?.saving || loadingAddTotvs}
                                                                    />
                                                                </div>
                                                            </div>
                                                            ) : (
                                                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '25px' }}>
                                                                    <S.Loading />
                                                                </div>
                                                            )
                                                        ) : null}
                                                    </AcordionCard>
                                                );
                                            })
                                        ) : (
                                            <div style={{ width: "100%", padding: "16px 0", display: "flex", justifyContent: "center" }}>
                                                <BodyPSpan color={theme.colors.gray.Cinza_2} style={{ width: "auto", textAlign: "center" }}>
                                                    Nenhum novo usuário encontrado.
                                                </BodyPSpan>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ) : null}

                            <ModalTesteGratisAcabou
                                show={modalTesteGratisAcabou}
                                title="Essa é uma função exclusiva para assinantes..."
                                subtitle="Assine o Agroreceita para desbloquear todos os recursos abaixo:"
                                onHide={() => {
                                    setModalTesteGratisAcabou(false);
                                    window.location.href="/"
                                }}
                            ></ModalTesteGratisAcabou>

                            <ModalFuncaoBloqueada
                                    show={modalTesteGratis}
                                    onHide={() => {
                                        setModalTesteGratis(false);
                                        window.location.href="/"
                                    }}
                            ></ModalFuncaoBloqueada>
                        </Container>
                    </UserIndexContainer>
                </>
            )}
        />
    )
}

export default Usuario;
